import { IsDefined, IsString } from 'class-validator';

export class RefreshJwtTokenResponse {
    @IsDefined()
    @IsString()
    public accessToken: string;

    @IsDefined()
    @IsString()
    public refreshToken: string;

    constructor(data?: Partial<RefreshJwtTokenResponse>) {
        this.accessToken = data?.accessToken;
        this.refreshToken = data?.refreshToken;
    }
}
